import styled from "styled-components";

export const Wrapper = styled.div`
  & > div:last-child {
    margin-bottom: 0;
  }
`;
